module.exports = __webpack_public_path__ + "img/stepcounter-checkmark.610461e8.svg";